module.exports = __webpack_public_path__ + "img/blue_022.0b20efc3.png";